import { backendClient } from "@/lib/backend-api";
import { safe } from "@orpc/client";

export const subscribeToShopEventStream = async (signal: AbortSignal) => {
  const result = await safe(backendClient.realtime.stream(undefined, { signal }));

  if (!result.isSuccess) {
    return null;
  }

  return result.data;
};
